import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin-bottom: 10rem;
`;

export const MarginBottom: React.FC = () => {
  return <Container />;
};
